var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.594 14.465 4.428 5.903h6.509l-7.307-9.742 6.08-6.994H17.84l-4.757 5.472-4.105-5.472H2.469l6.984 9.311-6.455 7.425h2.465zm5.358 4.044L6.189 5.49h1.86L17.81 18.51z"
  })));
};
export default SvgX;